@if (alternateNumbers().length) {
  <div class="col-12" data-automation="teams-alternate-numbers">
    <div class="row">
      <div class="col-12">
        <legend>{{ 'tkey;microsoft_360.view.teams.calling.alternate_numbers.label' | translate }}</legend>
      </div>
    </div>
    <ul class="list-unstyled row">
      @for (alternateNumber of alternateNumbers(); track alternateNumber.lineUri + alternateNumber.lineUriExtension) {
        <li class="col-6">
          <div class="card mb-3 px-4 d-flex align-items-center flex-row justify-content-between">
            <div class="d-flex flex-column justify-content-center py-2">
              <p class="mb-0">
                <strong data-automation="alternate-number">
                  {{ alternateNumber.lineUri | telephoneNumberFilter }}
                </strong>
                @if (alternateNumber.lineUriExtension) {
                  <span data-automation="alternate-number-extension">
                    {{
                      'tkey;microsoft_360.view.teams.calling.alternate_numbers.extension.label'
                        | translate: { extension: alternateNumber.lineUriExtension }
                    }}
                  </span>
                }
              </p>
              <p class="card-text mb-0">
                <span data-automation="alternate-number-type">
                  {{ phoneNumberTypeLabels[alternateNumber.phoneNumberType] | translate }}
                </span>
                @if (alternateNumber.emergencyLocation) {
                  <span data-automation="alternate-number-emergency-location">
                    | {{ alternateNumber.emergencyLocation.description }}
                  </span>
                }
              </p>
            </div>
            <div class="d-flex align-items-center">
              <ziro-button
                [dataAutomation]="'delete-alternate-number'"
                [buttonStyle]="buttonStyles.OUTLINE_DANGER"
                [buttonSize]="buttonSizes.SMALL"
                [icon]="ziroIcons.DELETE_SMALL"
                (clicked)="onDeleteClicked(alternateNumber)"
              ></ziro-button>
            </div>
          </div>
        </li>
      }
    </ul>
  </div>
}
